<template>
  <p>
    La estación de Huayao es el corazón de LAMAR en el Observatorio de Huancayo
    y es considerada como una “Estación Climatológica Principal”. Cuenta con
    instrumentos "tradicionales" y las observaciones se realizan tres veces al
    día a través de un convenio con
    <a href="http://www.senamhi.gob.pe/" target="_blank">
      SENAMHI
    </a>
    . Por otro lado, la estación cuenta con instrumental automático que registra
    continuamente.
  </p>
  <p>
    Los instrumentos “tradicionales” actualmente en operación en la estación
    son:
  </p>
  <List marked>
    <li>
      <b>Lectura directa</b>
      <List marked>
        <li>Termómetro de máxima</li>
        <li>Termómetro de mínima</li>
        <li>Geotermómetro a 100 cm</li>
        <li>Barómetro patrón</li>
        <li>Anemómetro y veleta</li>
        <li>Psicrómetro</li>
        <li>Termómetro de mínima a 10 cm del suelo</li>
      </List>
    </li>
    <li>
      <b>Registradores</b>
      <List marked>
        <li>Microbarógrafo</li>
        <li>Termógrafo</li>
        <li>Higrógrafo</li>
        <li>Pluviógrafo</li>
      </List>
    </li>
    <li>
      <b>Totalizadores</b>
      <List marked>
        <li>Heliógrafo</li>
        <li>Tanque de evaporación tipo A</li>
        <li>Pluviómetro</li>
      </List>
    </li>
  </List>
  <p>Los instrumentos automáticos son:</p>
  <List marked>
    <li>Sensores de temperatura a 2 m y 10 cm del suelo</li>
    <li>Sensor de humedad relativa</li>
    <li>Piranómetros Campbell y Lanat</li>
    <li>Sensor de presión</li>
    <li>Pluviómetro</li>
    <li>Anemómetros y veletas a 3 y 10 m de altura</li>
    <li>Geotermómetros a 20 y 50 cm de profundidad</li>
  </List>
</template>
<script>
import List from "@/components/ui/objects/List";
export default {
  components: {
    List,
  },
  setup() {},
};
</script>
